export { default as CarouselPost } from "./carousel-post";
